import { NgModule } from '@angular/core';
import { BrowserUtils } from '@azure/msal-browser';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FailedComponent } from './failed/failed.component';
import { OilPanddModule } from './modules/oil-pandd/oil-pandd.module';
import { AuthGuard } from './shared/services/auth.guard';
import { InvalidFileComponent } from './invalid-file/invalid-file.component';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'main',
  //   pathMatch: 'full'
  // },
  {
    path: '',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    // Needed for hash routing
    path: 'error',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule)
  },
  {
    // Needed for hash routing
    path: 'state',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule)
  },
  {
    // Needed for hash routing
    path: 'code',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'login-failed',
    component: FailedComponent
  },

  {
    path: 'invalid-file',
    component: InvalidFileComponent
  }

  // {
  //   path: 'dashboard',
  //   loadChildren: () => import('./modules/oil-pandd/oil-pandd.module').then(m => m.OilPanddModule),
  //   canActivate: [MsalGuard]
  // },
  // {
  //   path: 'main',
  //   loadChildren: () => import('./main/main.module').then(m => m.MainModule),
  //   canActivate: [MsalGuard]
  // },
  // {
  //   path: 'login-failed',
  //   component: FailedComponent
  // },
  // {
  //   path: '',
  //   loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  // },
  // {
  //   path: '',
  //   loadChildren: () => import('./main/main.module').then(m => m.MainModule),
  // },
  // {
  //   path: '',
  //   loadChildren: () => import('./main/main.module').then(m => m.MainModule),
  //   canActivate: [
  //     MsalGuard
  //   ]
  // }
];

// const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      // Don't perform initial navigation in iframes or popups
      initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
